import { Rule } from 'antd/lib/form';

export const NOT_REQUIRED: Rule = { required: false };
export const REQUIRED: Rule = { required: true };
export const FILES_MESSAGE: Rule = { message: 'Загрузите документ' };
export const COMMENT_MESSAGE: Rule = { message: 'Введите комментарий' };
export const PROJECT_MESSAGE: Rule = { message: 'Выберите Проект' };
export const STRUCTURES_MESSAGE: Rule = { message: 'Выберите Объект' };
export const CONTRACTS_MESSAGE: Rule = { message: 'Выберите Договор' };

export const notRequired: Rule[] = [NOT_REQUIRED];
export const filesMessage: Rule[] = [{ ...REQUIRED, ...FILES_MESSAGE }];
export const commentMessage: Rule[] = [{ ...REQUIRED, ...COMMENT_MESSAGE }];
export const projectMessage: Rule[] = [{ ...REQUIRED, ...PROJECT_MESSAGE }];
export const structureMessage: Rule[] = [{ ...REQUIRED, ...STRUCTURES_MESSAGE }];
export const contractMessage: Rule[] = [{ ...REQUIRED, ...CONTRACTS_MESSAGE }];
